module.exports = new __parcel__URL__("the-design-of-everyday-things.60a4bcc9.jpg").toString();